export interface ReceiveSession {
  sessionId: string;
  receiveAddress: `0x${string}`;
  startedAtMs: number;
}

export function createReceiveSession(
  receiveAddress: `0x${string}`,
  nowMs = Date.now(),
): ReceiveSession {
  return {
    sessionId: `${receiveAddress.toLowerCase()}:${nowMs}`,
    receiveAddress,
    startedAtMs: nowMs,
  };
}

export function restartReceiveSession(
  _currentSession: ReceiveSession | undefined,
  receiveAddress: `0x${string}`,
  nowMs = Date.now(),
): ReceiveSession {
  return createReceiveSession(receiveAddress, nowMs);
}

export function isReceiveWalletMismatch(
  session: ReceiveSession | undefined,
  connectedAddress: `0x${string}` | undefined,
): boolean {
  if (!session || !connectedAddress) {
    return false;
  }
  return session.receiveAddress.toLowerCase() !== connectedAddress.toLowerCase();
}
